/**
 * Created by Markus on 15.6.2015.
 * In this case sections are considered the level 1 pages that have children (1 or more)
 */

define('helperNavigation-isSectionLastPage',[],function() {
    'use strict';

    var isSectionLastPage = function(ID, arr, level) {
        var i, res, entity;

        if (!ID || !Array.isArray(arr)) {
            return null;
        }

        i = arr.length;
        arr = [].concat(arr);
        if(!level) level = 1;

        while(i--) {
            entity = arr[i];

            if (entity.hasOwnProperty('contentEntityId') && entity.contentEntityId === ID) {
                if(level == 1){
                    // main level page
                    return false;
                }else if(i+1 == arr.length){
                    return true;
                }

            } else if (entity.hasOwnProperty('children') && Array.isArray(entity.children) && entity.children.length && level == 1) {
                res = isSectionLastPage(ID, entity.children, level + 1);
                if (res) {
                    return res;
                }
            }
        }

        return false;
    };

    return isSectionLastPage;

});

